import { frontendURL } from '../../../helper/URLHelper';
import MercadoHost from '../mercado/MercadoHost.vue';
import { LAIS_CAPTACAO_PERMISSIONS } from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/mercado/mudancas'),
    alias: [
      frontendURL('accounts/:accountId/mudancas'),
      frontendURL('accounts/:accountId/mudanças'),
      frontendURL('accounts/:accountId/alteracoes'),
      frontendURL('accounts/:accountId/laudos/mudancas'),
    ],
    name: 'mudancas_index',
    component: MercadoHost,
    meta: { permissions: LAIS_CAPTACAO_PERMISSIONS },
  },
];
